import axios from "axios";
import router from '@/router';
import store from "@/store";
import refreshToken from "@/utils/refreshToken";
import defaultUser from "@/module_user/defaultUser.json";

const baseURL = process.env.VUE_APP_API_URL;

const instance = axios.create({
    baseURL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
});

instance.interceptors.request.use(async function (config) {
    let token = localStorage.getItem("token");
    config.headers['Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    else {
        const localUserInfo = defaultUser[0];
        localUserInfo.unintercepted = true;
        const resp = await store.dispatch('saveAnonymousUser', localUserInfo);
        if (resp.status === 200) {
            token = resp.data.token;
            config.headers["Authorization"] = `Bearer ${token}`;
        }
    }

    return config;
}, function (error) {
    return Promise.reject(error);
});

instance.interceptors.response.use((response) => { return response }, function (error) {

    const status = error.response ? error.response.status : null
    const skipRefresh = error.response ? (error.response.config.headers['ef-skip-refresh'] ?? false) : false;

    if (status === 401 && !skipRefresh) {
        return refreshToken().then(_ => {
            const accessToken = localStorage.getItem('token');
            error.config.headers['Authorization'] = 'Bearer ' + accessToken;
            error.config.baseURL = undefined;
            return instance.request(error.config);
        }).catch(e => {
            if (e.response.status === 401) {
                if (!JSON.parse(localStorage.getItem('userInfo')).isAnonymousUser) {
                    store.dispatch('logout');
                    alert('Your session has expired. Please login again.');
                    // router.push("/login");
                }
                return Promise.reject(e);
            }
        });
    }
    return Promise.reject(error);
});


export default instance;
